import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { GlobalStyle } from 'stylecomponents';
import BreadCrumbs from 'components/commons/BreadCrumbs';
import GameBlock from 'components/game/GameBlock';
import TradeDetail from 'components/game/TradeDetail';
import ProductDetail from 'components/game/ProductDetail';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import CupoyRouter from "components/commons/router/CupoyRouter";
import GLOBAL from 'nonnglobal';

const Container = styled.div`
  display: grid;
  grid-template-columns: 244px 1fr;
  margin-top: ${GlobalStyle.ViewSpace}px;
  grid-gap: ${GlobalStyle.ViewSpace}px;
`

const Main = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-gap: ${GlobalStyle.ViewSpace}px;
`


class PurchaseDetail extends PureComponent {

  constructor(props) {
    super(props);

    const routerState = CupoyRouter.getCurrent();
    const { params } = routerState;

    const {
      gameid,
      gameserverid,
      vprovmrscid,
      purchaseid
    } = params;

    this.state = {
      gameid,
      gameserverid,
      vprovmrscid,
      purchaseid,

      dollar: '',
      ntdollar: undefined,
      vitemdollar: undefined,
      conversion: undefined,
      proportion: undefined,
      minlimit: undefined,
      maxlimit: undefined,
      error_dollarInput: false,
      error_input: '',
      isPurchasePage: false,
      viprovname: '',
      serverrole: '',
      txtcontent: '',
      orderprocess: '',
      ordertime: '',
      bankaccount: '',
      bankData: [],
      currentBankCode: '',
      currentBank: '',
      currentSubBankCode: '',
      currentSubBank: '',
      defaultgrade: 0,
      bankcode: '',
      bank: '',
      subbank: '',
      subname: '',
      subcode: '',
      agree: false,
      isValidationError: true,
      isServerroleError: false,
      isOrdertimeError: false,
      isOrderprocessError: false,
      isBankcodeError: false,
      isSubcodeError: false,
      isBankaccountError: false,
      isAgreeError: false,
      isOpen: false,
    };

    this.updateTxtContentDollar = this.updateTxtContent.bind(this, 'dollar'); 
    this.updateTxtContentServerrole = this.updateTxtContent.bind(this, 'serverrole'); 
    this.updateTxtContentOrdertime = this.updateTxtContent.bind(this, 'ordertime'); 
    this.updateTxtContentOrderprocess = this.updateTxtContent.bind(this, 'orderprocess'); 
    this.updateTxtContentBankcode = this.updateTxtContent.bind(this, 'bankcode'); 
    this.updateTxtContentBankaccount = this.updateTxtContent.bind(this, 'bankaccount');
    this.chooseEvaluationToNeutral = this.chooseEvaluation.bind(this, 0);
    this.chooseEvaluationToNegative = this.chooseEvaluation.bind(this, 1);

  }

  componentDidMount() {
    window.scrollTo({ top: 0 });
    this.init();
  }

  init = () => {

    const {
      gameid,
      gameserverid,
      vprovmrscid,
      purchaseid
    } = this.state;

    const purchaseMap = this.props.purchaseMap;
    const gameListMap = this.props.gameListMap;

    if (Object.keys(gameListMap).length === 0) {
      this
        .props
        .gameActions
        .listGames();
    }
    if (Object.keys(purchaseMap).length === 0) {
      this
        .props
        .vitemActions
        .listPurchases({gameid, gameserverid})
        .then(() => {
          this.initState();
        });
    } else {
      this.initState();
    }

    if (this.props.haslogin){
      this
        .props
        .vitemActions
        .initPurchaseOrder({gameid, gameserverid, vprovmrscid, purchaseid})
        .then(() => {
          this.setState({isValidationError: false})
        }, error => {

          let errorMsg = '請重新登入';
          let errorDescription = '';

          if (error && error.code) {
            switch (error.code) {
              case 'error.privilege.noLogin':
                return;
              default:
                errorMsg = error.message + '，無法建立訂單！';
                break;
            }
          }
          this
            .props
            .webActions
            .openAlertDialog({title: errorMsg, description: errorDescription});
        });

      import ('../../json/bank.json').then((result) => {
        this.setState({bankData: result.default });
      }).catch(err => {
        console.log(err)
      });
    }
  }

  initState = () => {

    const purchaseMap = this.props.purchaseMap;
    const { gameid, gameserverid, vprovmrscid } = this.state;

    const purchaser = purchaseMap[`${vprovmrscid},${gameid},${gameserverid}`];

    const {
      ntdollar,
      vitemdollar,
      maxlimit,
      minlimit,
    } = purchaser;

    const proportion = vitemdollar / ntdollar;

    this.setState({
      ntdollar,
      vitemdollar,
      conversion: Math.round(minlimit * proportion),
      proportion,
      maxlimit: +maxlimit,
      minlimit: +minlimit,
      isOpen: GLOBAL.getVProviderIsOpen(purchaser),
    });
  }

  updateTxtContent = (updateInput, event) => {
    if (updateInput === 'dollar') {
      const { proportion } = this.state;
      const regexp = /^[0-9]*$/;
      if(!regexp.test(event.target.value))
        return;
      console.log(Math.round(Number(event.target.value) * proportion));
      this.setState({
        [updateInput]: Number(event.target.value),
        conversion: Math.round(Number(event.target.value) * proportion)
      });
    } else if (updateInput === "bankcode") {
      const bankcode = event.target.value;
      if (bankcode && bankcode.length >= 3) {
        const _bankcode = bankcode.substring(0, 3);
        const bankData = this.state.bankData;
        for (let index in bankData) {
          const bank = bankData[index];
          if (bank.bankcode.indexOf(_bankcode) === 0) {
            this.setState({currentBank: bank, currentBankCode: bank.bankcode, currentSubBank: '', currentSubBankCode: ''});

            // for loop 找尋分行
            if (bankcode.length >= 7) {
              if (Array.isArray(bank.subbank)) {

                for (let index in bank.subbank) {
                  const subbank = bank.subbank[index];
                  const combBankCode = bank.bankcode + subbank.subcode;
                  if (combBankCode === bankcode) {
                    this.setState({currentSubBank: subbank, currentSubBankCode: subbank.subcode});
                  }
                }
              }
            } else {
              this.setState({currentSubBank: '', currentSubBankCode: ''});
            }
          }
        }
      }
      this.setState({[updateInput]: event.target.value});
    } else {
      this.setState({[updateInput]: event.target.value});
    }
  }

  addTradeMoney = () => {
    const { minlimit, dollar, proportion } = this.state;
    
    if(dollar < minlimit) {
      this.setState({
        dollar: minlimit,
        conversion: Math.round(Number(minlimit) * proportion),
      });
      return;
    }

    this.setState(prevState => ({
      dollar: +prevState.dollar + 1,
      conversion: Math.round((+prevState.dollar + 1) * proportion), 
    }));
  }

  minusTradeMoney = () => {
    const { minlimit, dollar, proportion } = this.state;

    if(dollar < minlimit) {
      this.setState({
        dollar: minlimit,
        conversion: Math.round(Number(minlimit) * proportion),
      });
      return;
    }

    if(((dollar - 1) < 0 || (dollar - 1) < minlimit)) 
      return;
    this.setState(prevState => ({
      dollar: +prevState.dollar - 1,
      conversion: Math.round((+prevState.dollar - 1) * proportion), 
    }));
  }

  onBankChange = event => {
    const bankCode = event.target.value;
    const bankData = this.state.bankData;
    for (let index in bankData) {
      const bank = bankData[index];
      if (bank.bankcode === bankCode) {
        this.setState({currentBank: bank, currentBankCode: bank.bankcode, currentSubBank: '', currentSubBankCode: '', bankcode: bank.bankcode});
        break;
      }
    }
  }

  onSubBankChange = event => {
    const bankCode = event.target.value;
    const currentBank = this.state.currentBank;
    for (let index in currentBank.subbank) {
      const bank = currentBank.subbank[index];
      if (bank.subcode === bankCode) {
        this.setState({
          currentSubBank: bank,
          currentSubBankCode: bank.subcode,
          bankcode: this.state.currentBankCode + bank.subcode
        });
        break;
      }
    }
  }

  chooseEvaluation = evaluation => {
    this.setState({ defaultgrade: evaluation });
  }

  toggleAgree = () => {
    this.setState(prevState => ({
      agree: !prevState.agree
    }));
  }

  validateDollar = () => {

    const {
      dollar,
      maxlimit,
      minlimit,
      ntdollar,
    } = this.state;

    const { purchaseMap } = this.props;
    const { gameid, gameserverid, vprovmrscid } = this.state;
    const purchase = purchaseMap[`${vprovmrscid},${gameid},${gameserverid}`];

    const {
      selllimittype,
      selllimitval,
      hadBoughtVitem,
    } = purchase;

    const sellLimit = selllimittype > 0 ? selllimittype : selllimitval;

    if ((sellLimit > 0) && !hadBoughtVitem){
      this.props.webActions.openAlertDialog({
        title: '錯誤訊息',
        description: `此『虛寶市集-遊戲幣收購區』會員已設定【${selllimittype > 0 ? selllimittype : selllimitval}週內】購買遊戲幣的週期限制，因您於『虛寶市集-遊戲幣出售區』無購買紀錄所以無法販售商品，不予收購此筆交易!`,
        closeName: '關閉',
      });
      return;
    }

    if ((dollar <= maxlimit && dollar >= minlimit) && (dollar % ntdollar === 0)) {

      this.setState({error_dollarInput: false, isPurchasePage: true});

      this.orderValidate();

    } else {
      this.setState({error_dollarInput: true});
      this
        .props
        .webActions
        .openAlertDialog({
          title: '錯誤訊息',
          description: '出售金額只能大於' + minlimit + '小於' + maxlimit + '且為' + ntdollar + '的倍數',
          closeName: '關閉',
          // closeCallback: () => this.error_focus()
        });
    }
  }

  orderValidate = () => {

    const {
      dollar, // 交易金額(台幣)
      maxlimit, // 最大交易金額(台幣)
      minlimit, // 最小交易金額(台幣)
      ntdollar, // 交易金額台幣比例
      serverrole, // 角色名稱
      ordertime, // 交易時間
      orderprocess, // 交易過程詳述
      currentBank, // 銀行資料  *
      currentSubBank, // 分行資料 *
      bankaccount, // 銀行帳號
      defaultgrade, // 評價
      agree, // 同意交易
    } = this.state;

    const { gameid, gameserverid, purchaseid, vprovmrscid } = this.state;
    const { memberid: vprovmemberid } = this.props.purchaseMap[`${vprovmrscid},${gameid},${gameserverid}`];
    const { addPurchaseOrder } = this.props.vitemActions;

    let isDollarError = false;
    let isError = false;
    let isServerroleError = false;
    let isOrdertimeError = false;
    let isOrderprocessError = false;
    let isBankcodeError = false;
    let isBankaccountError = false;
    let isAgreeError = false;

    if (!(dollar <= maxlimit && dollar >= minlimit) || !(dollar % ntdollar === 0)) { // 出售金額檢查
      isError = true;
      isDollarError = true;
    }
    if (!serverrole.trim()) {
      isError = true;
      isServerroleError = true;
    }
    if (!ordertime.trim()) {
      isError = true;
      isOrdertimeError = true;
    }
    if (!orderprocess.trim()) {
      isError = true;
      isOrderprocessError = true;
    }
    if (!currentBank.bankcode || !currentSubBank.subcode) {
      isError = true;
      isBankcodeError = true;
    }
    if (!(bankaccount && bankaccount.length <= 14)) {
      isError = true;
      isBankaccountError = true;
    }
    if (!agree) {
      isError = true;
      isAgreeError = true;
    }

    this.setState({
      error_dollarInput: isDollarError,
      isServerroleError,
      isOrdertimeError,
      isOrderprocessError,
      isBankcodeError,
      isBankaccountError,
      isAgreeError
    });

    if (isError) {

      // if (isDollarError) {
      //   this
      //     .numberInput
      //     .focus();

      // } else if (isServerroleError) {
      //   this
      //     .serverroleInput
      //     .focus();

      // } else if (isOrdertimeError) {
      //   this
      //     .ordertimeInput
      //     .focus();

      // } else if (isOrderprocessError) {
      //   this
      //     .orderprocessInput
      //     .focus();

      // } else if (isBankcodeError) {
      //   this
      //     .bankcodeInput
      //     .focus();

      // } else if (isBankaccountError) {
      //   this
      //     .bankaccountInput
      //     .focus();
      // }
    } else {

      addPurchaseOrder({ // 需要建立訂單 執行addPurchaseOrder
        'purchaseid': purchaseid,
        'gameid': gameid,
        'itemprice': dollar,
        'vprovmemberid': vprovmemberid.trim(),
        'vprovmrscid': vprovmrscid,
        'defaultgrade': defaultgrade,
        'serverrole': serverrole,
        'ordertime': ordertime,
        'orderprocess': orderprocess,
        'bankcode': currentBank.bankcode,
        'bank': currentBank.bank,
        'subbank': currentSubBank.subcode,
        'bankaccount': bankaccount
      }).then((result) => {
        this
          .props
          .webActions
          .openAlertDialog({title: "", description: "交易完成後後請至會員資訊內『虛寶市集＞收購區＞指定收購區』進行供貨商評價。"});
        this
          .props
          .webActions
          .cupoyStateGo(CupoyRouter.STATES.MEMBER_VITEM_ORDER_PURCHASE);

      }, (error) => {
        let errorMsg = '請重新登入';
        let errorDescription = '';

        if (error && error.code) {
          switch (error.code) {
            case 'error.privilege.noLogin':
              return;
            default:
              errorMsg = error.message;
              break;
          }
        }

        this
          .props
          .webActions
          .openAlertDialog({title: errorMsg, description: errorDescription});
      });
    }
  }

  render() {

    const { haslogin } = this.props;

    return (
      <GlobalStyle.SubContainer>
        {haslogin ? this.renderHasLogin() : this.renderNoLogin()}
      </GlobalStyle.SubContainer>
    )
  }

  renderHasLogin = () => {
    
    const {
      gameid,
      gameserverid,
      vprovmrscid,
      dollar,
      ntdollar,
      vitemdollar,
      minlimit,
      maxlimit,
      defaultgrade,
      serverrole,
      orderprocess,
      bankcode,
      conversion,
      agree,
      bankData,
      currentBankCode,
      currentBank,
      currentSubBankCode,
      ordertime,
      error_dollarInput,
      isServerroleError,
      isOrdertimeError,
      isOrderprocessError,
      isBankcodeError,
      isBankaccountError,
      isAgreeError,
      bankaccount,
      proportion,
    } = this.state;

    const {
      purchaseMap,
      gameListMap,
    } = this.props;


    if (Object.keys(gameListMap).length === 0) {
      return null;
    }
    if (Object.keys(purchaseMap).length === 0) {
      return null;
    }

    const { idximg } = gameListMap[gameid];

    const {
      gamename = '',
      nickname = '',
      notice = '',
      selllimittype,
      selllimitval,
    } = purchaseMap[`${vprovmrscid},${gameid},${gameserverid}`];

    const sellLimit = selllimittype > 0 ? selllimittype : selllimitval;
    const gameImgSrc = `${GLOBAL.imgSrcRootURL}/gameimgs/${gameid}/${idximg}`;

    const path = {
      preState: 'game',
      preTitle: '收購區遊戲列表',
      title: gamename.trim(),
    };

    const data = {
      name: nickname.trim(),
      money: `${ntdollar} : ${vitemdollar}`,
      vPrice: (dollar > 0) ? conversion || 0 : 0,
      dollar,
      maxDollar: maxlimit,
      minDollar: minlimit,
      proportion,
      bankcode,
      currentBank,
      currentBankCode,
      bankData,
      currentSubBankCode,
      bankaccount,
      defaultgrade,
      agree,
      character: serverrole,
      descriptoin: orderprocess,
      tradetime: ordertime,
      isServerroleError,
      isOrdertimeError,
      isOrderprocessError,
      isBankcodeError,
      isBankaccountError,
      isAgreeError,
      error: error_dollarInput,
    };

    return (
      <React.Fragment>
        <BreadCrumbs path={path} />
        <Container>
          <GameBlock title={gamename.trim()} img={gameImgSrc} />
          <Main>
            <TradeDetail
              isPurchase
              data={data}
              mode="purchase"
              handleCharacterInput={this.updateTxtContentServerrole}
              handleTradetimeInput={this.updateTxtContentOrdertime}
              handleDescriptoinInput={this.updateTxtContentOrderprocess}
              addTradeMoney={this.addTradeMoney}
              minusTradeMoney={this.minusTradeMoney}
              handleDollarChange={this.updateTxtContentDollar}
              updateTxtContentBankcode={this.updateTxtContentBankcode}
              onBankChange={this.onBankChange}
              onSubBankChange={this.onSubBankChange}
              updateTxtContentBankaccount={this.updateTxtContentBankaccount}
              chooseEvaluationToNeutral={this.chooseEvaluationToNeutral}
              chooseEvaluationToNegative={this.chooseEvaluationToNegative}
              toggleAgree={this.toggleAgree}
              submit={this.validateDollar}
              disableSubmit={!this.state.isOpen}
            />
            <ProductDetail
              isPurchase
              sellLimit={sellLimit}
              selllimittype={selllimittype}
              selllimitval={selllimitval}
              minlimit={minlimit}
              maxlimit={maxlimit}
              notice={notice}
            />
          </Main>
        </Container>
      </React.Fragment>
    );
  }

  renderNoLogin = () => (
    <GlobalStyle.BasicBlock>
      <GlobalStyle.ErrorContainer>
        <GlobalStyle.ErrorContainerTitle>您尚未登入</GlobalStyle.ErrorContainerTitle>
        <GlobalStyle.ErrorContainerDesription>您尚未登入，請登入後再重新操作一次。</GlobalStyle.ErrorContainerDesription>
      </GlobalStyle.ErrorContainer>
    </GlobalStyle.BasicBlock>
  )

}
/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function (state) {
  return {
    haslogin: state.member.haslogin,
    purchaseMap: state.vitem.purchaseMap,
    gameListMap: state.game.gameListMap,
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function (dispatch) {
  return {
    webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
    vitemActions: bindActionCreators(actionCreators.vitemActionCreators, dispatch),
    gameActions: bindActionCreators(actionCreators.gameActionCreators, dispatch)
  };
};

/*--------------------------
  export
--------------------------*/
export default connect(
  mapStateToProps,
  mapActionToProps,
  null,
  { forwardRef: true }
)(PurchaseDetail);
